import { render, staticRenderFns } from "./FundTransactionForm.vue?vue&type=template&id=5ebfa968&scoped=true"
import script from "./FundTransactionForm.vue?vue&type=script&lang=js"
export * from "./FundTransactionForm.vue?vue&type=script&lang=js"
import style0 from "./FundTransactionForm.vue?vue&type=style&index=0&id=5ebfa968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebfa968",
  null
  
)

export default component.exports